<template>
    <div class="text-xs-center div-notificacao-mensagem div-notificacao-mensagem-menu">
        <v-menu
            v-model="deveMostrarPopupMensagens"
            :close-on-content-click="false"
            offset-y
            transition="slide-x-transition"
            bottom
            left
            min-width="300"
            max-width="350"
            @input="processarAbrirFecharNotificacoesChat"
        >
            <template v-slot:activator="{ on }">
                <v-btn v-on="on" icon class="ma-0">
                    <v-badge right overlap color="secondary">
                        <template v-slot:badge>
                            <span v-if="chat.msgResumidasNaoLidas > 0">{{ chat.msgResumidasNaoLidas }}</span>
                        </template>
                        <v-icon size="18"  style="color:#777777;">fas fa-comment-alt</v-icon>
                    </v-badge>
                </v-btn>
            </template>

            <v-list>
                <v-list-tile>
                    <h3>Mensagens</h3>
<!--                    <v-spacer></v-spacer>-->
<!--                    <v-btn color="primary" class="text-capitalize" flat @click="deveMostrarPopupMensagens = false">Ver todas</v-btn>-->
                </v-list-tile>
                <v-divider></v-divider>
                <v-list-tile v-if="deveMostarMensagemZeroMensagem" class="py-5">
                  <p class="v-card__title">Não há nenhuma mensagem ainda.</p>
                </v-list-tile>

                <notificacao-mensagem-lista v-else @carregarMaisMensagens="loadChatNotifications">
                    <notificacao-mensagem v-for="mensagem in mensagensResumidas"
                                          :key="mensagem.id"
                                          :mensagem="mensagem"
                                          @click.native="marcarMsgNotificacaoComoLida(mensagem)"/>
                    <div v-show="loading" class="text-md-center">
                        <v-progress-circular
                            indeterminate
                            color="primary"
                        ></v-progress-circular>
                    </div>
                </notificacao-mensagem-lista>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
import NotificacaoMensagemLista from '@/views/pages/commons/chat-compra-direta/notificacao/NotificacaoMensagemLista'
import {mapState} from 'vuex'
import NotificacaoMensagem from '@/views/pages/commons/chat-compra-direta/notificacao/NotificacaoMensagem'
import {actionTypes, mutationTypes} from '@/core/constants'

export default {
    name: 'NotificacaoMensagemMenu',
    components: {NotificacaoMensagem, NotificacaoMensagemLista},
    data: () => ({
        deveMostrarPopupMensagens: false,
        loading: false,
    }),
    computed: {
        ...mapState(['chat', 'loki']),
        deveMostarMensagemZeroMensagem(){
            return this.chat.mensagensResumidas.length <= 0
        },
        mensagensResumidas(){
            return this.chat.mensagensResumidas
        },
        deveRealizarPaginacao() {
            const totalPages = this.chat.paginacao.totalPages
            const page = this.chat.paginacao.page
            return page <= totalPages
        },
        ehPerfilComprador(){
            return this.loki.user.domainId && this.loki.user.domainType === 'ESTRUTURA_ORGANIZACIONAL'
        },
        ehSessaoValida(){
            return this.loki.user.domainId && this.loki.user.domainType !== 'DEFAULT'
        }
    },
    async mounted() {
        await this.contarNotificacoesNaoLidas()
    },
    methods: {
        async processarAbrirFecharNotificacoesChat(menuEstaAberto) {
            if (menuEstaAberto)
                await this.buscarMensagensNotificao()
            else
                this.$store.commit(mutationTypes.SET_CHAT_MENSAGENS_NOTIFICACOES_PAGE, 1)
        },
        async loadChatNotifications () {
            if (this.deveRealizarPaginacao) {
                this.$store.commit(mutationTypes.SET_CHAT_MENSAGENS_NOTIFICACOES_PAGE)
                this.loading = true
                await this.buscarMensagensNotificao()
                this.loading = false
            }
        },
        async buscarMensagensNotificao() {
            if(this.ehPerfilComprador)
                await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_NOTIFICACOES_CHAT_COMPRADOR)
            else if(this.ehSessaoValida)
                await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_NOTIFICACOES_CHAT_FORNECEDOR)
        },
        async contarNotificacoesNaoLidas() {
            if(this.ehPerfilComprador)
                await this.$store.dispatch(actionTypes.COMPRADOR.CONTAR_NOTIFICACOES_NAO_LIDAS_CHAT_COMPRADOR)
            else if(this.ehSessaoValida)
                await this.$store.dispatch(actionTypes.FORNECEDOR.CONTAR_NOTIFICACOES_NAO_LIDAS_CHAT_FORNECEDOR)
        },
        async marcarMsgNotificacaoComoLida(mensagem) {
            if (!mensagem.lida) await this.$store.dispatch(actionTypes.MARCAR_NOTIFICACAO_MENSAGEM_LIDA, mensagem.id)

            await this.atualizarDadosChatNoEstado(mensagem)

            if(this.ehPerfilComprador)
                this.redirecionarComprador(mensagem)
            else
                this.redirecionarFornecedor(mensagem)
            this.$store.commit(mutationTypes.SET_CURRENT_TAB_CHAT, 'tab-mensagens')
            this.$store.commit(mutationTypes.SET_DEVE_ABRIR_CHAT, true)
            this.$root.$emit('notificacaoMensagemClicked')
        },
        async atualizarDadosChatNoEstado(mensagem) {
            const destinatario = {
                iniciais: this.getInicias(mensagem.remetente.nome),
                ...mensagem.remetente
            }
            const detalhes = {
                compraDiretaId: mensagem.compraDiretaId,
                processo: mensagem.processo,
                itemOuLoteDescricao: mensagem.loteOuItemDescricao,
                itemCompraDiretaId: ('ITEM' === mensagem.tipoElemento) ? mensagem.elementoId : null,
                loteCompraDiretaId: ('LOTE' === mensagem.tipoElemento) ? mensagem.elementoId : null,
                tipo: mensagem.tipoElemento
            }
            this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_MENSAGENS, [])
            this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_DETALHES_COMPRA, detalhes)
            this.$store.commit(mutationTypes.SET_CHAT_CONVERSACAO_DESTINATARIO, destinatario)
            await this.buscarMensagensConversacaoChat()
        },
        redirecionarFornecedor(mensagem) {
            this.$router.push({
                name: 'DocumentoPropostaDoFornecedor',
                params: {
                    id: mensagem.compraDiretaId,
                    propostaId: mensagem.propostaId,
                }
            })
        },
        redirecionarComprador(mensagem) {
            const location = this.$router.resolve({
                name: 'Resultado',
                params: {
                    id: mensagem.compraDiretaId,
                },
                query: this.$route.query
            })
            window.location.href = location.href
        },
        getInicias(nomeDestinatario){
            const parts = nomeDestinatario.split(' ')
            if(parts.length > 1)
                return `${parts[0].charAt(0)}${parts[1].charAt(0)}`.toUpperCase()
            return parts[0].substring(0, 2).toUpperCase()
        },
        async buscarMensagensConversacaoChat() {
            if (this.ehPerfilComprador)
                await this.$store.dispatch(actionTypes.COMPRADOR.BUSCAR_DESTINATARIO_CHAT_E_MENSAGENS)
            else
                await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_CONVERSACAO_CHAT_MENSAGENS)
        }
    }
}
</script>

<style scoped lang="stylus">
    .v-progress-circular
        margin: 1rem
</style>